import { Heading } from 'roo-ui/components';

const GroupHeading = ({ children }) => (
  <Heading.h4 fontSize="lg" mb={0}>
    {children}
  </Heading.h4>
);

export default GroupHeading;
